import { api } from '@/lib/axios'

export async function GetParceirosFn() {
  const response = await api.get('parceiros')

  return response.data
}
